<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择事故"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      :handleSearchData="handleSearchData"
      @change="handleResultChange"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'certificatesInsuranceFee'">
          <span>{{scope.row[scope.column.property] / 100}}</span>
        </section>
        <section v-else>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  accidentList,
} from 'api/cost';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'insuranceNumber',
      tableSelectTar: 'id',
      searchBoxDataTmpl: {
        form: [
          { // 出险时间
            label: '出险时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择出险时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'licenceTypeName',
          label: '证照类型',
        },
      ],
      tableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号',
        },
        {
          prop: 'accidentStateName',
          label: '事故状态',
        },
        {
          prop: 'insuranceCompany',
          label: '保险公司',
        },
        {
          prop: 'insuranceUserName',
          label: '被保险人',
        },
        {
          prop: 'insuranceStartDate',
          label: '起保日期',
        },
        {
          prop: 'insuranceEndDate',
          label: '终保日期',
        },
        {
          prop: 'insuranceNumber',
          label: '保单号',
        },
        {
          prop: 'accidentTime',
          label: '出险日期',
        },
        {
          prop: 'reportTime',
          label: '报案日期',
        },
        {
          prop: 'responsibilityAttributionName',
          label: '责任归属',
        },
        {
          prop: 'isVehicleDamageName',
          label: '本车车损',
        },
        {
          prop: 'isOtherAccidentName',
          label: '对方车损',
        },
        {
          prop: 'isGoodsDamageName',
          label: '物损',
        },
        {
          prop: 'isRoadDamageName',
          label: '道路损',
        },
        {
          prop: 'isWoundingName',
          label: '人伤标志',
        },
        {
          prop: 'repairServiceName',
          label: '维修服务商',
        },
        {
          prop: 'repairServiceAmt',
          label: '维修金额',
        },
        {
          prop: 'repairServiceAddress',
          label: '维修地点',
        },
        {
          prop: 'repairServiceTel',
          label: '联系方式',
        },
        {
          prop: 'isRepairCompleteName',
          label: '是否完结',
        },
      ],
    };
  },
  methods: {
    getListApi: accidentList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      if (searchBoxData.Time[0]) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0], 1);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1], 1);
      }
      delete searchBoxData.Time;
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
